import { number } from 'prop-types';
import * as classNames from './UKPriceTable.module.css';

const UKPriceTable = ({ sum, tax }) => (
  <div className={classNames.container}>
    <div className={classNames.table}>
      <div className={classNames.row}>
        <div className={classNames.textColumn}>Sub-Total:</div>
        <div className={classNames.numberColumn}>{`$${sum.toFixed(2)}`}</div>
      </div>
      <div className={classNames.row}>
        <div className={classNames.textColumn}>Tax:</div>
        <div className={classNames.numberColumn}>{`$${tax.toFixed(2)}`}</div>
      </div>
      <div className={classNames.row}>
        <div className={classNames.textColumn}>Total:</div>
        <div className={classNames.numberColumn}>{`$${(sum + tax).toFixed(2)}`}</div>
      </div>
    </div>
  </div>
);

UKPriceTable.propTypes = {
  sum: number.isRequired,
  tax: number.isRequired,
};

export default UKPriceTable;
